import api from './api'
import Cookies from 'js-cookie'

export async function login(username, password) {
    try {
        const res = await api.post('/api/auth/signin', {
            username: username,
            password: password
        })
        if (res.data && res.data.token) {
            Cookies.set('token', res.data.token)
            window.location.href = '/mobile-menu'
        } else {
            alert('Sai tài khoản hoặc mật khẩu!')
        }
    } catch (err) {
        console.error('Login error:', err)
        if (err.response && err.response.data && err.response.data.error) {
            alert(err.response.data.error)
        } else {
            alert('Không thể kết nối đến máy chủ. Vui lòng kiểm tra lại backend!')
        }
    }
}

export function logout() {
    // Clear token from cookie
    Cookies.remove('token')

    // Redirect to login page
    window.location.href = '/login'
}

